export default __webpack_public_path__ + "static/Group-1259-36f8a87b6d29fc8065422a9cdf32b230.png";